import { DRAG_DROP } from "../../../constants/actionTypes";
import { IArticlesItem } from "../interfaces";
const dragDropInitialState = {
  isDragging: false,
  draggedItem: {} as IArticlesItem,
  selectedIds: [],
  contentAbandon: false,
  droppedArticles: false,
  previewImageURL: "",
  newPreviewImage: "",
  hoveredAssetId: 0,
  gillRoyMoveUp: false,
};

export const dragDropReducer = (state = dragDropInitialState, action: any) => {
  const new_state = { ...state };
  switch (action.type) {
    case DRAG_DROP.IS_DRAG:
      new_state.isDragging = action.payload?.isDrag;
      new_state.draggedItem = action.payload?.item;
      return new_state;

    case DRAG_DROP.SET_SELECTED_ID:
      const { id, add } = action.payload;
      let list: any = [...new_state.selectedIds];
      if (add) list = [...list, id];
      else list = list.filter((item: any) => item !== id);
      new_state.selectedIds = list;
      return new_state;

    case DRAG_DROP.REMOVE_SELECTED_ID:
      new_state.selectedIds = [];
      return new_state;

    case DRAG_DROP.OPEN_ABANDON_POPUP:
      new_state.contentAbandon = true;
      return new_state;

    case DRAG_DROP.CLOSE_ABANDON_POPUP:
      new_state.contentAbandon = false;
      return new_state;

    case DRAG_DROP.SET_IMAGE:
      new_state.previewImageURL = action.payload;
      return new_state;

    case DRAG_DROP.SET_NEWIMAGE:
      new_state.newPreviewImage = action.payload;
      return new_state;

    case DRAG_DROP.SET_CHECK_ARTICLES:
      new_state.droppedArticles = action.payload;
      return new_state;

    case DRAG_DROP.SET_HOVERED_ASSET_ID:
      new_state.hoveredAssetId = action.payload;
      return new_state;

    case DRAG_DROP.GILL_ROY_MOVE_UP:
      new_state.gillRoyMoveUp = true;
      return new_state;

    case DRAG_DROP.GILL_ROY_MOVE_DOWN:
      new_state.gillRoyMoveUp = false;
      return new_state;

    case DRAG_DROP.RESET_SELECTED_IDS:
      new_state.selectedIds = [];
      return new_state;

    default:
      return new_state;
  }
};
